let analytics;

class SegmentIOLoader {
  init(apiKey) {
    this._loadSegmentLib();
    /* Set 'Write API' key */
    analytics.load(apiKey);
  }

  setGroup(groupId) {
    analytics.group(groupId);
  }

  _loadSegmentLib() {
    analytics = analytics || [];
    if (!analytics.initialize) {
      if (analytics.invoked) {
        throw new Error('Segment snippet included twice.');
      } else {
        analytics.invoked = !0;
        analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview',
          'identify', 'reset', 'group', 'track', 'ready', 'alias', 'page', 'once', 'off', 'on'];
        analytics.factory = (t) => {
          return (...args) => {
            const e = Array.prototype.slice.call(args);
            e.unshift(t);
            analytics.push(e);
            return analytics;
          };
        };
        for (let t = 0; t < analytics.methods.length; t++) {
          const e = analytics.methods[t];
          analytics[e] = analytics.factory(e);
        }
        analytics.load = (t) => {
          const e = document.createElement('script');
          e.type = 'text/javascript';
          e.async = !0;
          e.src = `${(document.location.protocol === 'https:' ? 'https://' : 'http://')}cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`;
          const n = document.getElementsByTagName('script')[0];
          n.parentNode.insertBefore(e, n);
        };
        analytics.SNIPPET_VERSION = '3.1.0';
      }
    }
  }
}

export const segmentLoaderInstance = new SegmentIOLoader();
